export default __webpack_public_path__ + "static/media/goshen35.4ee6bcec.jpg";